import { css } from 'styled-components';

export const gridRow = css``;

export const gridColumn = css``;
